<template>
  <div class="hello container">
    <div>
      <p class="serverName">{{school_name}}</p>
    </div>
    <div class="row">
      <div v-if="totalStatsVisible === 4">
        <div class="ss">
          <div class="smallstats col s12 m12 l4 hide-on-small-only" v-if="activeStudents">
            <div class="card hoverable center card-medium-smallStats darken-1">
              <div class="card-content black-text">
                <div class="row">
                  <div class="col s12 m12 l12">
                    <p class="md-title2">ACTIVE STUDENTS</p>
                  </div>
                </div>
                <div class="row">
                  <div class="col s12 m12 l12">
                    <pie-chart class="piechart"
                      v-bind:ratio="ratio"
                      :percent=100
                      :stroke-width=0.5
                      color=#FFC709
                      :opacity=1
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="ss">
          <div class="statistics col s12 m12 l8 hide-on-small-only hide-on-med-only" v-if="analyticsStats">
            <div class="card hoverable card-medium-stats darken-1 center">
              <div class="card-content black-text">
                <div class="row">
                  <div class="col m12 l4">
                    <p class="md-title2 hide-on-med-only">FLASHCARDS FLIPPED</p>
                  </div>
                  <div class="col m12 l4">
                    <p class="md-title2 hide-on-med-only">RESOURCES PUSHED TO STUDENTS</p>
                  </div>
                  <div class="col m12 l4">
                    <p class="md-title2 hide-on-med-only">PAGES SAVED</p>
                  </div>
                </div>
                <div class="row">
                  <div class="center col m12 l4">
                    <div class="EllipsesStats hide-on-med-only">
                      <img class="ellipse" alt="Vue logo" src="../assets/stats/Ellipse_blue.png">
                      <img class="ellipseIcon" alt="Vue logo" src="../assets/stats/clone_green.png">
                      <p class="md-subheading score">{{student_flashcards | thousands}}</p>
                    </div>
                  </div>
                  <div class="center col m12 l4">
                    <div class="EllipsesStats hide-on-med-only">
                      <img class="ellipse" alt="Vue logo" src="../assets/stats/Ellipse_red.png">
                      <img class="ellipseIcon" alt="Vue logo" src="../assets/stats/upload_red.png">
                      <p class="md-subheading score">{{resources_pushed | thousands}}</p>
                    </div>
                  </div>
                  <div class="center col m12 l4">
                    <div class="EllipsesStats hide-on-med-only">
                      <img class="ellipse" alt="Vue logo" src="../assets/stats/Ellipse_green.png">
                      <img class="ellipseIcon" alt="Vue logo" src="../assets/stats/tree_blue.png">
                      <p class="md-subheading score">{{pages_saved | thousands}}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-for="(c,index) in content" :key="index">
        <div v-if="c.show" class="col s12 m6 l4">
          <div class="card hoverable card-small card-small-border-15 darken-1" v-bind:style="{'border-color': c.color}">
            <div class="card-content black-text center">
              <a class="hrefLink" v-if="c.link !== ''" :href="c.link" target="_BLANK">
                <span class="card-title"><p class="card-small-title">{{c.title}}</p></span>
                <p class="card-small-description">{{c.description}}</p>
              </a>
              <div v-else>
                <span class="card-title"><p class="card-small-title">{{c.title}}</p></span>
                <p class="card-small-description">{{c.description}}</p>
                <br>
                <div class="row">
                  <div  v-if="c.action">
                    <div v-for="(link, l) in c.action.buttons" :key="l" class="col s4 m4 l4" applogos>
                      <md-button :href="c.action.links[l]" target="_BLANK" class="md-icon-button appbutton"><font-awesome-icon :icon="['fab', c.action.buttons[l]]" size="3x" v-bind:style="{ 'color': c.color }"/></md-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'portal',
  data () {
    return {
      ratio: 0.0001,
      student_flashcards: 0,
      resources_pushed: 0,
      pages_saved: 0,
      school_name: '',
      activeStudents: true,
      analyticsStats: true,
      analytics: false,
      totalStatsVisible: 0,
      BColors: [
        '#78F4F4',
        '#FA6AFF',
        '#3DB7FF',
        '#88D958',
        '#FFC709',
        '#ED4B72',
        '#78F4F4',
        '#FA6AFF',
        '#3DB7FF',
        '#88D958',
        '#FFC709',
        '#ED4B72',
        '#78F4F4'
      ],
      content: [
        {
          id: 0,
          title: 'Educator Console',
          serverTitle: 'unity',
          description:
            'Create assessments, push resources to learners’ e-books and develop your own Educator Folders.',
          link: '/educator',
          show: false,
          color: '#000'
        },
        {
          id: 1,
          title: 'Analytics',
          serverTitle: 'analytics',
          description:
            'View trends and analytics on the use of the ITSI Solution by your staff and students.',
          link: '/analytics',
          show: false,
          color: '#000'
        },
        {
          id: 2,
          title: 'Admin',
          serverTitle: 'admin',
          description:
            'Manage your institution’s e-books and create book lists.',
          link: 'http://admin.it.si',
          show: false,
          color: '#000'
        },
        {
          id: 3,
          title: 'Educator Resources',
          serverTitle: 'resourcestore',
          description: 'Download free additional resources.',
          link: '/resourcestore',
          show: false,
          color: '#000'
        },
        {
          id: 4,
          title: 'Professional Development',
          serverTitle: 'PD',
          description: 'Make informed decisions about 21st-century teaching.',
          link: 'https://www.itsieducation.com/professional-development/',
          show: false,
          color: '#000'
        },
        {
          id: 5,
          title: 'Learning Tools',
          serverTitle: 'LT',
          description:
            'Access additional learning tools to enhance the learning experience.',
          link: 'https://store.it.si/za/search?page=1&productTypeFilter=3',
          show: false,
          color: '#000'
        },
        {
          id: 6,
          title: 'Online Store',
          serverTitle: 'store',
          description: 'Browse our selection of top academic and free e-books.',
          link: 'https://store.it.si/za/home',
          show: false,
          color: '#000'
        },
        {
          id: 7,
          title: 'Intelligent Practice',
          serverTitle: 'siyavula',
          description:
            'Learn, grow and master your high school Maths and Science skills. Brought to you by ITSI and Siyavula Education.',
          link: 'http://itsi.intelligentpractice.co.za/',
          show: false,
          color: '#000'
        },
        {
          id: 8,
          title: 'Pharos',
          serverTitle: 'pharos',
          description:
            'PharosOnline is a collection of general and subject dictionaries on the internet.',
          link: '/pharos',
          show: false,
          color: '#000'
        },
        {
          id: 9,
          title: 'yTeach',
          serverTitle: 'yteach',
          description:
            'yTeach is a collection of educational resources for Math, Science, Special Needs and English.',
          link: '/yteach',
          show: false,
          color: '#000'
        },
        {
          id: 10,
          title: 'Moodle',
          serverTitle: 'moodle',
          description: 'Access your institution’s Moodle platform.',
          link: '/moodle',
          show: false,
          color: '#000'
        },
        {
          id: 11,
          title: 'miEbooks',
          serverTitle: 'miebooks',
          description: 'Download the miEbooks app.',
          link: '',
          action: {
            buttons: ['android', 'apple', 'windows'],
            links: ['https://play.google.com/store/apps/details?id=za.co.itschools&hl=en', 'https://itunes.apple.com/us/app/miebooks/id881060638?mt=8', 'http://apps.microsoft.com/windows/en-za/app/miebooks/5bb733c7-64c3-428c-bdcf-e4200b0b4ba9']
          },
          show: false,
          color: '#000'
        },
        {
          id: 12,
          title: 'miEbooks Web',
          serverTitle: 'webreader',
          description: 'Open the miEbooks application in your web browser',
          link: '/reader',
          show: false,
          color: '#000'
        },
        {
          id: 13,
          title: 'Digital Lessons',
          serverTitle: 'lessons',
          description: 'View Digital Lessons for Mathematics, Life Sciences, Physical Sciences and Natural Sciences.',
          link: '/lessons',
          show: false,
          color: '#000'
        }
      ]
    }
  },
  methods: {
    getId (group) {
      for (let k = 0; k < this.content.length; k++) {
        if (this.content[k].serverTitle === group) {
          return this.content[k].id
        }
      }
    },
    isOnline (online) {
      if (online) {
        for (let k = 0; k < this.content.length; k++) {
          if (this.content[k].title === 'Online Store') {
            this.content[k].show = true
          } else if (this.content[k].title === 'Learning Tools') {
            this.content[k].show = true
          } else if (this.content[k].title === 'Intelligent Practice') {
            this.content[k].show = false
          } else if (this.content[k].title === 'Professional Development') {
            this.content[k].show = true
          }
        }
      }
    },
    assigncolors () {
      var color = 0
      for (let k = 0; k < this.content.length; k++) {
        if (this.content[k].show) {
          this.content[k].color = this.BColors[color]
          color++
        }
      }
    },
    removeCards () {
      var removeList = ['yteach']
      for (let j = 0; j < removeList.length; j++) {
        for (let k = 0; k < this.content.length; k++) {
          if (this.content[k].serverTitle === removeList[j]) {
            this.content[k].show = false
          }
        }
      }
    }
  },
  mounted: function () {
    this.axios.get('serverInfo.php').then(response => {
    // this.axios.get('http://10.70.1.32/serverinfo/serverInfo.php').then(response => {
      this.school_name = response.data.servername
      var id = -1
      for (let k = 0; k < response.data.services.length; k++) {
        id = this.getId(response.data.services[k].name.toLowerCase())
        if (id !== -1) {
          this.content[id].show = response.data.services[k].enabled
        }
        id = -1
      }

      var online = response.data.online
      this.isOnline(online)
      this.activeStudents = response.data.activeStudent

      for (let k = 0; k < response.data.stats.length; k++) {
        if (response.data.stats[k].name === 'flashcardTransitions') {
          this.student_flashcards = response.data.stats[k].stat
          if (this.student_flashcards !== 0.0 && this.student_flashcards !== 0 && this.student_flashcards > 1 && this.student_flashcards !== -1) {
            this.totalStatsVisible += 1
          }
        }
        if (response.data.stats[k].name === 'resourcesPushed') {
          this.resources_pushed = response.data.stats[k].stat
          if (this.resources_pushed !== 0.0 && this.resources_pushed !== 0 && this.resources_pushed > 1 && this.resources_pushed !== -1) {
            this.totalStatsVisible += 1
          }
        }
        if (response.data.stats[k].name === 'activeStudents') {
          this.ratio = response.data.stats[k].stat
          this.ratio = this.ratio / 100
          if (this.ratio > 1) {
            this.ratio = 1
            this.totalStatsVisible += 1
          } else if (this.ratio !== 0.0 && this.ratio !== 0 && this.ratio > 0.01 && this.ratio !== -1) {
            this.totalStatsVisible += 1
          }
        }
        if (response.data.stats[k].name === 'pagesSaved') {
          this.pages_saved = response.data.stats[k].stat
          if (this.pages_saved !== 0.0 && this.pages_saved !== 0 && this.pages_saved > 1 && this.pages_saved !== -1) {
            this.totalStatsVisible += 1
          }
        }
      }
      this.removeCards()
      this.assigncolors()
    }).catch(e => {
      console.log(e)
    })
  }
}
</script>

<style>
/* open-sans-regular - latin */
@font-face {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 400;
  src: url('~@/assets/fonts/open-sans-v16-latin-regular.eot'); /* IE9 Compat Modes */
  src: local('Open Sans Regular'), local('OpenSans-Regular'),
       url('~@/assets/fonts/open-sans-v16-latin-regular.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */
       url('~@/assets/fonts/open-sans-v16-latin-regular.woff2') format('woff2'), /* Super Modern Browsers */
       url('~@/assets/fonts/open-sans-v16-latin-regular.woff') format('woff'), /* Modern Browsers */
       url('~@/assets/fonts/open-sans-v16-latin-regular.ttf') format('truetype'), /* Safari, Android, iOS */
       url('~@/assets/fonts/open-sans-v16-latin-regular.svg#OpenSans') format('svg'); /* Legacy iOS */
}
.card {
  cursor: pointer;
  margin-bottom: 25px !important;
}

/* .row {
  border: 1px solid black;
}

.col {
  border: 1px solid black;
} */

.hrefLink {
  text-decoration: none !important;
}

.serverName {
  font-size: 36px;
  margin-top: 50px;
  color: white;
  text-align: center;
  line-height: 40px;
}

body {
  background: linear-gradient(to bottom right, #2e67b1, #000) fixed;
}

.card-small {
  height: 200px;
  max-width: 800px;
}

.card-small-border-15 {
  border-left: solid 15px blue;
}

text {
  color: blue !important;
}

.card-small-title {
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  font-size: 24px;
  text-align: center;
  color: rgba(0, 0, 0, 0.8);
}

.card-small-description {
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 300;
  line-height: normal;
  font-size: 18px;
  text-align: center;
  color: rgba(0, 0, 0, 0.8);
}

.card-medium-stats {
  height: 300px;
  max-width: 833px;
  cursor: default;
}

.card-medium-smallStats {
  height: 300px;
  max-width: 847px;
  cursor: default;
}

.piechart {
  max-width: 173px;
  max-height: 173px;
  font-family: "Open Sans";
  font-size: 12px !important;
  font-weight: 600;
  letter-spacing: 0ch;
  color: #FFC709 !important;
}

.appbutton {
  width: 50px !important;
  height: 50px !important;
  margin-left: -6% !important;
}

.md-title2 {
  font-size: 18px !important;
  text-align: center !important;
  font-weight: 400 !important;
}

.EllipsesStats {
  text-align: center;
  position: relative;
}

.ellipse {
  max-width: 100%;
  max-height: 100%;
}

.ellipse-small {
  max-width: 30%;
  max-height: 30%;
}

.ellipseIcon{
  width: 46px;
  height: 34px;
  text-align: center;
  position: absolute;
  left: calc(50% - 23px);
  top: 35px;
}

.score{
  color: white;
  position: absolute;
  top: 70%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 24px !important;
}

@media only screen and (min-width: 1194px) and (max-width: 1320px) {
  .card-small-title {
    font-family: "Open Sans";
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    font-size: 20px;
    text-align: center;
    color: rgba(0, 0, 0, 0.8);
  }

  .ellipseIcon{
    width: 40px;
    height: 28px;
    text-align: center;
    position: absolute;
    left: calc(50% - 20px);
    top: 35px;
  }

  .card-small-description {
    font-family: "Open Sans";
    font-style: normal;
    font-weight: 300;
    line-height: normal;
    font-size: 16px;
    text-align: center;
    color: rgba(0, 0, 0, 0.8);
  }

  .score{
    color: white;
    position: absolute;
    top: 70%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 22px !important;
  }
}

@media only screen and (min-width: 993px) and (max-width: 1193px) {
  .card-small-title {
    font-family: "Open Sans";
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    font-size: 17px;
    text-align: center;
    color: rgba(0, 0, 0, 0.8);
  }

  .fa-3x {
    font-size: 2.5em;
  }

 .appbutton {
    width: 40px !important;
    height: 40px !important;
    /* margin-left: -20px !important; */
  }

  .card-small-description {
    font-family: "Open Sans";
    font-style: normal;
    font-weight: 300;
    line-height: normal;
    font-size: 13px;
    text-align: center;
    color: rgba(0, 0, 0, 0.8);
  }
}

@media only screen and (min-width: 600px) and (max-width: 749px) {
  .card-small-title {
    font-family: "Open Sans";
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    font-size: 20px;
    text-align: center;
    color: rgba(0, 0, 0, 0.8);
  }

  .appbutton {
    width: 50px !important;
    height: 50px !important;
    /* margin-left: -25px !important; */
  }

  .card-small-description {
    font-family: "Open Sans";
    font-style: normal;
    font-weight: 300;
    line-height: normal;
    font-size: 16px;
    text-align: center;
    color: rgba(0, 0, 0, 0.8);
  }
}

@media only screen and (min-width: 603px) and (max-width: 662px) {
  .card-small-title {
    font-family: "Open Sans";
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    font-size: 17px;
    text-align: center;
    color: rgba(0, 0, 0, 0.8);
  }

  .fa-3x {
    font-size: 2.5em;
  }

  .appbutton {
    width: 40px !important;
    height: 40px !important;
  }

  .card-small-description {
    font-family: "Open Sans";
    font-style: normal;
    font-weight: 300;
    line-height: normal;
    font-size: 15px;
    text-align: center;
    color: rgba(0, 0, 0, 0.8);
  }
}

@media only screen and (min-width: 601px) and (max-width: 602px) {
  .card-small-title {
    font-family: "Open Sans";
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    font-size: 15px;
    text-align: center;
    color: rgba(0, 0, 0, 0.8);
  }

  .fa-3x {
    font-size: 2.5em;
  }

  .appbutton {
    width: 40px !important;
    height: 40px !important;
  }

  .card-small-description {
    font-family: "Open Sans";
    font-style: normal;
    font-weight: 300;
    line-height: normal;
    font-size: 15px;
    text-align: center;
    color: rgba(0, 0, 0, 0.8);
  }
}

@media only screen and (min-width: 993px) and (max-width: 1261px) {
  .statistics {
    display: none;
  }
  .ss .l4 {
    width: 100% !important;
  }
}
</style>
